<template>
  <v-app>
    <v-app-bar app color="white" class="elevation-3 px-2">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="hidden-sm-and-up"
      ></v-app-bar-nav-icon>
      <!-- <v-divider vertical inset class="hidden-sm-and-up mr-4"></v-divider> -->

      <div class="logo">
        <a href="https://www.accelefreight.com" class="navbar-brand logo">
          <img src="@/assets/logo.svg" alt="AcceleFreight" width="120px" />
        </a>
      </div>

      <v-divider vertical inset class="hidden-xs-only"></v-divider>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <!-- Home -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/home"
          >HOME</v-btn
        >

        <!-- About Us -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/aboutus"
          >ABOUT US</v-btn
        >

        <!-- Our Services -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/ourservices"
          >SERVICES</v-btn
        >

        <!-- F.A.Q -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/frequentquestions"
          >F.A.Q</v-btn
        >

        <!--Contact Us -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/contact"
          >CONTACT US</v-btn
        >

        <!--Track Shipment -->
        <!-- <v-menu bottom offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn class="app-bar-btn font-weight-light body-2" text v-on="on">
              TRACK
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-text-field
                style="max-width: 350px;"
                label="INSERT TRACKING ID"
                outlined
                dense
                height="52"
                class="em-text-field"
                v-model="tracking_id"
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-btn
                depressed
                tile
                large
                block
                color="primary"
                class="font-weight-bold body-1 ml-1"
                @click="trackShipment(tracking_id)"
                >TRACK</v-btn
              >
            </v-list-item>
          </v-list>
        </v-menu>-->
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <template v-if="loggedIn">
        <v-btn
          :href="`${CONSTANT.HOSTNAME}/login`"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold mr-4 hidden-sm-and-down"
          >Login</v-btn
        >
        <v-btn
          :href="`${CONSTANT.HOSTNAME}/register`"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold hidden-sm-and-down"
          >Get Started</v-btn
        >
      </template>
      <template v-else>
        <v-btn
          :href="`${CONSTANT.HOSTNAME}/user/dashboard`"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold hidden-sm-and-down"
          >Dashboard</v-btn
        >
      </template>
    </v-app-bar>

    <!-- Nav drawer for Mobile/Tab view -->
    <v-navigation-drawer app temporary v-model="drawer" class="hidden-md-and-up">
      <template v-slot:prepend>
        <v-row justify="center" class="pt-4">
          <div class="logo">
            <a href="https://www.accelefreight.com" class="navbar-brand logo">
              <img src="@/assets/logo.svg" alt="AcceleFreight" width="150px" />
            </a>
          </div>
        </v-row>
      </template>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          href="https://www.accelefreight.com/home"
          class="text-decoration-none"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-light title primary--text"
              >HOME</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          href="https://www.accelefreight.com/aboutus"
          class="text-decoration-none"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-light title primary--text"
              >ABOUT US</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          href="https://www.accelefreight.com/ourservices"
          class="text-decoration-none"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-light title primary--text"
              >SERVICES</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          href="https://www.accelefreight.com/frequentquestions"
          class="text-decoration-none"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-light title primary--text"
              >F.A.Q</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          href="https://www.accelefreight.com/contact"
          class="text-decoration-none"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-light title primary--text"
              >CONTACT US</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="grey lighten-3">
      <v-snackbar
        v-model="showSnackbar"
        :color="snackbarColor"
        :timeout="snackbarTimeout"
        content-class="font-weight-bold"
        :top="true"
      >
        {{ snackbarMsg }}
        <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
      </v-snackbar>
      <v-container fluid class="white">
        <v-row>
          <v-col>
            <v-row no-gutters class="mb-3">
              <v-col>
                <v-row justify="center" v-show="!new_track_row">
                  <v-btn
                    text
                    color="primary"
                    class="font-weight-bold body-1"
                    @click="new_track_row = true"
                    >TRACK ANOTHER SHIPMENT</v-btn
                  >
                </v-row>

                <v-row v-show="new_track_row" no-gutters>
                  <v-col>
                    <v-row justify="center" class="mb-10">
                      <span class="title text--secondary text-center">
                        Enter a valid Accele Freight provided tracking id or Accele
                        Freight shipment id
                      </span>
                    </v-row>
                    <v-row justify="center">
                      <v-text-field
                        style="max-width: 350px"
                        label="TRACKING ID"
                        outlined
                        dense
                        height="52"
                        class="em-text-field"
                        v-model="tracking_id"
                      ></v-text-field>

                      <v-btn
                        depressed
                        tile
                        x-large
                        color="primary"
                        class="font-weight-bold body-1 ml-1"
                        @click="trackShipment(tracking_id)"
                        >TRACK</v-btn
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-divider></v-divider>
            </v-row>

            <!-- Shipment Detail -->
            <v-row no-gutters>
              <v-col>
                <v-row v-if="shipment != null" no-gutters>
                  <v-col>
                    <v-row v-if="shipment != null" justify="space-around">
                      <span class="text--secondary text-center px-2 body-2">
                        <span class="font-weight-bold">Tracking ID:</span>
                        {{ shipment.tracking_id }}
                      </span>
                      <span class="text--secondary text-center px-2 body-2">
                        <span class="font-weight-bold">Shipment ID:</span>
                        {{ shipment.shipment_order_id }}
                      </span>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-row justify="center">
                          <span
                            :class="`text-h4 text-center ${
                              shipment.status == 10000
                                ? 'green--text text--darken-3'
                                : 'amber--text text--darken-4'
                            }`"
                            >{{ getCurrentStatus().status }}</span
                          >
                        </v-row>

                        <v-row justify="center">
                          <span class="text--secondary text-center">
                            {{ getCurrentStatus().dt }}
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- Shipment Workflow Milestone for sm - xl -->
                    <v-row
                      no-gutters
                      justify="center"
                      class="py-4 pl-2 hidden-sm-and-down"
                    >
                      <template v-for="(wf_item, ind) in workflowProcesses">
                        <v-col
                          style="max-width: 12%"
                          :key="`hr${ind}`"
                          v-if="ind !== 0"
                          class="mr-n13"
                        >
                          <hr
                            :class="`hr-line mt-3 ml-n13 ${
                              setProcessStyle(wf_item).color
                            }`"
                          />
                        </v-col>

                        <v-col style="max-width: 82px">
                          <v-row class="mb-1">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-responsive
                                  :key="ind"
                                  v-on="on"
                                  :class="`pb-1 rounded-circle text-center align-center justify-center ${
                                    setProcessStyle(wf_item).color
                                  }`"
                                  height="30"
                                  max-width="30"
                                >
                                  <v-icon size="18" color="white">
                                    {{ setWorkflowIcon(wf_item) }}
                                  </v-icon>
                                </v-responsive>
                              </template>
                              {{ wf_item.alias }}
                            </v-tooltip>
                          </v-row>

                          <v-row class="py-1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-row v-on="on" no-gutters class="caption">
                                  <span>{{ setWFProcessLabel(wf_item).line_1 }}</span>
                                </v-row>
                              </template>
                              <span>{{ setWFProcessLabel(wf_item).line_1_tooltip }}</span>
                            </v-tooltip>
                          </v-row>

                          <v-row>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-row no-gutters v-on="on" class="caption-line-2">
                                  {{ setWFProcessLabel(wf_item).line_2 }}
                                </v-row>
                              </template>
                              <span>{{ setWFProcessLabel(wf_item).line_2_tooltip }}</span>
                            </v-tooltip>
                          </v-row>
                        </v-col>
                      </template>
                    </v-row>

                    <!-- Shipment Workflow Milstone for xs (mobile view) -->
                    <v-row class="hidden-md-and-up" no-gutters justify="center">
                      <v-col cols="11" sm="7" md="6" lg="10">
                        <v-card flat>
                          <v-row justify="center" no-gutters>
                            <v-col cols="10" sm="10" md="10">
                              <v-card flat>
                                <template v-for="(wf_item, ind) in workflowProcesses">
                                  <v-row :key="`v${ind}`" v-if="ind !== 0">
                                    <div
                                      :class="`v-line ${setProcessStyle(wf_item).color}`"
                                    ></div>
                                  </v-row>

                                  <v-row no-gutters>
                                    <v-col cols="2">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-responsive
                                            v-on="on"
                                            :key="ind"
                                            :class="`pb-1 rounded-circle text-center align-center justify-center ${
                                              setProcessStyle(wf_item).color
                                            }`"
                                            height="35"
                                            max-width="35"
                                          >
                                            <v-icon size="18" color="white">
                                              {{ setWorkflowIcon(wf_item) }}
                                            </v-icon>
                                          </v-responsive>
                                        </template>
                                        {{ wf_item.alias }}
                                      </v-tooltip>
                                    </v-col>

                                    <v-col cols="10" class="pt-1">
                                      <v-row>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <v-row
                                              v-on="on"
                                              no-gutters
                                              class="caption text-uppercase"
                                            >
                                              <span
                                                class="d-inline-block text-truncate"
                                                style="max-width: 90%; font-size: 11px"
                                                >{{
                                                  setWFProcessLabel(wf_item, true).line_1
                                                }}</span
                                              >
                                            </v-row>
                                          </template>
                                          <span>{{
                                            setWFProcessLabel(wf_item).line_1_tooltip
                                          }}</span>
                                        </v-tooltip>
                                      </v-row>

                                      <v-row>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <v-row
                                              no-gutters
                                              v-on="on"
                                              class="caption text-uppercase"
                                            >
                                              {{ setWFProcessLabel(wf_item).line_2 }}
                                            </v-row>
                                          </template>
                                          <span>{{
                                            setWFProcessLabel(wf_item).line_2_tooltip
                                          }}</span>
                                        </v-tooltip>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </template>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row class="mt-4 pr-10" no-gutters>
                      <v-col cols="6" sm="6" md="3" class="pt-2">
                        <v-card flat>
                          <v-row>
                            <span class="font-weight-bold text--secondary body-2"
                              >Origin Port:</span
                            >
                          </v-row>
                          <v-row>
                            <span
                              class="font-weight-light text--secondary caption pr-5 pr-sm-4 pr-md-4"
                              >{{ shipment.quotation.origin_port.label }}</span
                            >
                          </v-row>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="6" md="3" class="pt-2">
                        <v-card flat>
                          <v-row>
                            <span class="font-weight-bold text--secondary body-2"
                              >Vessel Name:</span
                            >
                          </v-row>
                          <v-row>
                            <span
                              class="font-weight-light text--secondary caption pr-5 pr-sm-4 pr-md-4"
                            >
                              {{
                                shipment.quotation.shipment_schedule.vessel_name || "N/A"
                              }}
                            </span>
                          </v-row>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="6" md="3" class="pt-2">
                        <v-card flat>
                          <v-row>
                            <span class="font-weight-bold text--secondary body-2"
                              >Bill of Lading:</span
                            >
                          </v-row>
                          <v-row>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  style="max-width: 100%"
                                  class="d-inline-block text-truncate font-weight-light text--secondary caption pr-5 pr-sm-4 pr-md-4"
                                  >{{ shipment.misc.bill_of_lading || "N/A" }}</span
                                >
                              </template>
                              {{ shipment.misc.bill_of_lading || "N/A" }}
                            </v-tooltip>
                          </v-row>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="6" md="3" class="pt-2">
                        <v-card flat>
                          <v-row>
                            <span class="font-weight-bold text--secondary body-2"
                              >Destination Port:</span
                            >
                          </v-row>
                          <v-row>
                            <span
                              class="font-weight-light text--secondary caption pr-5"
                              >{{ shipment.quotation.destination_port.label }}</span
                            >
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-else justify="center">
                  <v-alert icon="mdi-information" dense text type="error"
                    >No shipment found</v-alert
                  >
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-divider class="mb-0"></v-divider>
            </v-row>

            <v-container fluid>
              <v-row v-if="shipment != null">
                <v-card flat width="100%">
                  <v-tabs background-color="white" color="primary" left>
                    <v-tab>Message Center</v-tab>

                    <v-tab-item>
                      <v-row v-if="sortedMessageList.length > 0" no-gutters>
                        <v-col class="px-1 pt-1">
                          <v-card tile flat color="white" class="pa-2" min-height="100">
                            <template v-for="(comment, i) in sortedMessageList">
                              <v-row :key="i">
                                <v-alert
                                  color="primary"
                                  border="left"
                                  elevation="0"
                                  colored-border
                                  tile
                                  min-width="100%"
                                  icon="mdi-message"
                                  class="pb-0 pt-1 pr-1"
                                >
                                  <v-row class="pb-1">
                                    <span class="caption font-weight-light">
                                      {{ comment.message }}
                                    </span>
                                  </v-row>

                                  <v-row justify="start" class="pt-1">
                                    <span class="sub-comment-text">
                                      {{ comment.createdStr }}
                                    </span>
                                  </v-row>
                                </v-alert>
                              </v-row>
                              <v-divider :key="`${i}divider`" class="my-2"></v-divider>
                            </template>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row v-else justify="center" class="mt-4">
                        <v-alert icon="mdi-information" dense text type="error"
                          >No comment available yet</v-alert
                        >
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import constant from "../../const";
import moment from "moment";

export default {
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,

      drawer: false,

      loggedIn: false,
      shipment: null,
      id: null,
      tracking_id: null,

      new_track_row: false,

      messageList: [],
    };
  },

  created() {
    this.$root.fullScreenView = false;
    this.id = this.$route.query.id;

    this.trackShipment(this.$route.query.id);
  },

  mounted() {
    // if environment is production
    // get the login cookies
    if (this.$cookies.isKey(constant.COOKIES_LOGIN_KEY)) {
      // parse the value to a json
      var parsed_token = this.$cookies.get(constant.COOKIES_LOGIN_KEY);
      if (parsed_token.status == "OK") {
        this.loggedIn = false;
      } else {
        this.loggedIn = true;
      }
    } else {
      console.log("no cookies");
    }
  },

  methods: {
    /**
     * Load tracked shipment information
     */
    trackShipment(track_id) {
      // validate track_id
      if (track_id == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "Invalid tracking id";
        return;
      }
      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "please wait...";
      axios
        .get(`${constant.API_HOST}/api/tracking/${track_id}`)
        .then((resp) => {
          // console.log("response: ", resp.data)
          history.pushState(null, null, `tracking?id=${track_id}`);

          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.shipment = resp.data.data;
            this.new_track_row = false;
            this.tracking_id = null;

            // fetch the comments
            this.fetchMessages();
          } else {
            console.error(resp.data);
            this.shipment = null;
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
          this.$root.blockUIshow = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * set the process style
     * @param {object} wf_item
     */
    setProcessStyle(wf_item) {
      var color = "";
      var title = "";

      // If in Progress
      if (wf_item.meta_data.start.status && !wf_item.meta_data.end.status) {
        color = "amber darken-4";
        title = "In Progress";
      }
      // If Completed
      else if (wf_item.meta_data.start.status && wf_item.meta_data.end.status) {
        color = "green darken-3";
        title = "Completed";
      }
      // not started
      else {
        color = "grey";
        title = "Not Started";
      }
      return { color: color, title: title };
    },

    /**
     * Set the workflow icon
     */
    setWorkflowIcon(wf_item) {
      let icon = constant.WORKFLOW_FORMAT[wf_item.process].icon;
      if (this.shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
        if (wf_item.process == "vessel_departure") {
          icon = "mdi-airplane-takeoff";
        } else if (wf_item.process == "vessel_in_transit") {
          icon = "mdi-airplane mdi-rotate-90";
        } else if (wf_item.process == "vessel_arrival") {
          icon = "mdi-airplane-landing";
        }
      }
      return icon;
    },

    /**
     * Set the Label messgae for the stepper workflow
     * @param {object} wf_item
     */
    setWFProcessLabel(wf_item, isMobile = false) {
      var line_1 = "";
      var line_2 = "";
      var line_1_tooltip = null;
      var line_2_tooltip = null;

      // If Shipment to port (Export)
      if (wf_item.process == "shipment_to_port") {
        // if FCL (Haulage)
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL) {
          // if the milestone is completed, then use milestone datetime as actual
          //* line 1 (delivery Schedule)
          if (wf_item.meta_data.start.status) {
            line_1 = `D: ${moment(wf_item.meta_data.start.datetime).format("MMM DD")}`;

            line_1_tooltip = "Container delivery";
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.haulage_export.delivery_schedule.start_datetime_str || "N/A"
            }`;

            line_1_tooltip = "Container delivery";
          }

          //* line 2 (Pull Back Schedule)
          if (wf_item.meta_data.end.status) {
            line_2 = `C: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;

            line_2_tooltip = "Containter collection";
          }
          // else use the planned haulage schedule
          else {
            line_2 = `C: ${
              this.shipment.haulage_export.pull_back_schedule.start_datetime_str || "N/A"
            }`;

            line_2_tooltip = "Containter collection";
          }
        }
        // if LCL or AIR (Transport)
        else {
          // if the milestone is completed, then use milestone datetime as actual
          //* (Transport Export Schedule)
          if (wf_item.meta_data.end.status) {
            line_1 = `P: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;

            line_1_tooltip = "Cargo pickup";
          }
          // else use the planned haulage schedule
          else {
            line_1 = `P: ${
              this.shipment.transport_export.schedule.start_datetime_str || "N/A"
            }`;
            line_1_tooltip = "Cargo pickup";
          }
        }
      }
      // If Shipment Delivery (Import)
      else if (wf_item.process == "shipment_delivery") {
        // If FCL (Haulage)
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL) {
          // if the milestone is completed, then use milestone datetime as actual
          //* line 1 (delivery Schedule)
          if (wf_item.meta_data.start.status) {
            line_1 = `D: ${moment(wf_item.meta_data.start.datetime).format("MMM DD")}`;

            line_1_tooltip = "Container delivery";
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.haulage_import.delivery_schedule.start_datetime_str || "N/A"
            }`;

            line_1_tooltip = "Container delivery";
          }

          //* line 2 (Pull Back Schedule)
          if (wf_item.meta_data.end.status) {
            line_2 = `C: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;

            line_2_tooltip = "Containter collection";
          }
          // else use the planned haulage schedule
          else {
            line_2 = `C: ${
              this.shipment.haulage_import.pull_back_schedule.start_datetime_str || "N/A"
            }`;

            line_2_tooltip = "Containter collection";
          }
        }
        // if LCL or AIR (Transport)
        else {
          // if the milestone is completed, then use milestone datetime as actual
          //* (Transport Import Schedule)
          if (wf_item.meta_data.end.status) {
            line_1 = `P: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;

            line_1_tooltip = "Cargo delivery";
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.transport_import.schedule.start_datetime_str || "N/A"
            }`;
            line_1_tooltip = "Cargo delivery";
          }
        }
      }

      //* Shipment Schedule
      // Vessel Departure
      else if (wf_item.process == "vessel_departure") {
        // for mobile view, display the port name instead
        line_1 = isMobile
          ? `${this.shipment.quotation.origin_port.name}, ${this.shipment.quotation.origin_port.country}`
          : this.shipment.quotation.origin_port.un_code;
        line_1_tooltip = this.shipment.quotation.origin_port.label;

        // use ETD for Air
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
          line_2 = "ETD: N/A";
          line_2_tooltip = "Estimated time of departure";

          // if atd, use the milestone time
          if (wf_item.meta_data.end.status) {
            line_2 = `ATD: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;
            line_2_tooltip = "Actual time of departure";
          }
          // else use the origin eta
          else if (this.shipment.quotation.shipment_schedule.origin_etd != null) {
            // if etd
            line_2 = `ETD: ${this.shipment.quotation.shipment_schedule.origin_etd_string}`;
            line_2_tooltip = "Estimated time of departure";
          }
        }
        // if FCL or LCL
        else {
          line_2 = "ETA: N/A";
          line_2_tooltip = "Estimated time of arrival";
          // if atd, use the milestone time
          if (wf_item.meta_data.end.status) {
            line_2 = `ATD: ${moment(wf_item.meta_data.end.datetime).format("MMM DD")}`;
            line_2_tooltip = "Actual time of departure";
          }
          // else use origin eta
          else if (this.shipment.quotation.shipment_schedule.origin_eta != null) {
            line_2 = `ETA: ${this.shipment.quotation.shipment_schedule.origin_eta_string}`;
            line_2_tooltip = "Estimated time of arrival";
          }
        }
      }
      // Vessel Arrival
      else if (wf_item.process == "vessel_arrival") {
        // for mobile view, display the port name instead
        line_1 = isMobile
          ? `${this.shipment.quotation.destination_port.name}, ${this.shipment.quotation.destination_port.country}`
          : this.shipment.quotation.destination_port.un_code;
        line_1_tooltip = this.shipment.quotation.destination_port.label;
        line_2 = "ETA: N/A";
        line_2_tooltip = "Estimated time of arrival";

        // if ata is not null, then use the Actual Time of arrival
        // if atd, use the milestone time
        if (wf_item.meta_data.start.status) {
          line_2 = `ATA: ${moment(wf_item.meta_data.start.datetime).format("MMM DD")}`;
          line_2_tooltip = "Actual time of arrival";
        }
        // else use the destination eta
        else if (this.shipment.quotation.shipment_schedule.destination_eta != null) {
          line_2 = `ETA: ${this.shipment.quotation.shipment_schedule.destination_eta_string}`;
          line_2_tooltip = "Estimated time of arrival";
        }
      }

      // Vessel in transit
      else if (wf_item.process == "vessel_in_transit") {
        line_1 = "Transit";
        line_1_tooltip = wf_item.alias;
      }

      // Export clearance
      else if (wf_item.process == "export_clearance") {
        line_1 = "Customs";
        line_1_tooltip = wf_item.alias;
      }

      // Import clearance
      else if (wf_item.process == "import_clearance") {
        line_1 = "Customs";
        line_1_tooltip = wf_item.alias;
      }

      // shipment closed
      else if (wf_item.process == "shipment_closed") {
        line_1 = "Completed";
        line_1_tooltip = wf_item.alias;
      }

      return {
        line_1: line_1,
        line_2: line_2,
        line_1_tooltip: line_1_tooltip,
        line_2_tooltip: line_2_tooltip,
      };
    },

    /**
     * Get the current status Date
     */
    getCurrentStatus() {
      let process = null;
      let dt = null;
      let levels = [];

      let len = this.shipment.shipment_workflow.workflow.length;
      let j = 0;

      // find the current process
      for (let i = 0; i < len; i++) {
        let index = len - 1 - i;
        const item = this.shipment.shipment_workflow.workflow[index];
        // store the levels for the real processes not alternate process
        if (item.included) {
          levels.push(item.level);

          // get the current process status
          // if the current process is completed
          if (item.meta_data.end.status) {
            process = item.alias;
            dt = moment(item.meta_data.end.datetime).format("dddd, Do MMMM YYYY");
            break;
          } else if (item.meta_data.start.status) {
            process = item.alias;
            dt = moment(item.meta_data.start.datetime).format("dddd, Do MMMM YYYY");
            break;
          } else {
            process = this.shipment.status_msg;
            dt = moment(this.shipment.last_status_updated).format("dddd, Do MMMM YYYY");
          }
        }
      }
      return { status: process, dt: dt };
    },

    /**
     * Fetch messages for this reference
     */
    fetchMessages() {
      this.messageList = [];
      //   this.$root.blockUImsg = "Loading messages...";
      //   this.$root.blockUIshow = true;
      var db = this.$root.messageCenterApp.firestore();
      db.collection("comments")
        .doc(this.shipment.shipment_order_id)
        .collection("messages")
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            this.messageList.push(doc.data());
          });
          //   this.$root.blockUIshow = false;
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
  },

  computed: {
    workflowProcesses() {
      let ret = [];
      if (this.shipment == null) {
        return [];
      } else {
        this.shipment.shipment_workflow.workflow.forEach((process) => {
          if (process.included) {
            ret.push(process);
          }
        });
        return ret;
      }
    },
    sortedMessageList: function () {
      return this.messageList.sort(function (a, b) {
        return new Date(b.createdStr) - new Date(a.createdStr);
      });
    },
  },
};
</script>

<style scoped>
.v-btn.app-bar-btn {
  text-decoration: none;
}
.app-bar-btn.v-btn--active {
  color: #1976d2;
  font-weight: bold !important;
  text-decoration: none;
}

.app-bar-btn:hover {
  background-color: #bcd0e4;
}

.v-input.v-text-field.em-text-field {
  margin-top: 0px;
  padding-top: 0px;
  border: 0px solid #e0e0e0 !important;
  border-radius: 0px;
}

hr.hr-line {
  border: 1.5px solid grey;
  max-width: 100%;
}

.v-line {
  border-left: 4px solid grey;
  height: 40px;
  position: relative;
  top: 0;
  margin-top: -1px;
  margin-left: 15px;
}

.v-alert {
  z-index: 1;
}

.v-application .caption-line-2 {
  /* font-size: 0.55rem !important; */
  font-size: 10px !important;
  letter-spacing: 0.025rem !important;
}
</style>
